import { DeleteKycProps, FinancialAccountUserAssociation } from '.';
import OrgsService from '../../services/orgs';
import { removeAccountRepresentative } from '../../services/vault/stripeConnectAccount';
import logger from '../../util/logger';

const submit = async ({
  stripeEnv,
  acctId,
  onSuccess,
}: DeleteKycProps): Promise<void> => {
  const financialAccount = await OrgsService.financialAcctId(acctId);
  logger('DeleteKyc financialAccount', false, financialAccount);
  if (!financialAccount?.finAcctId) {
    throw new Error('financial account missing finAcctId');
  }
  const representative = await OrgsService.getAccountRepresentative(
    financialAccount.finAcctId,
  );
  const usersThatShareKyc = await OrgsService.getFinancialAcctUsersByKycId(
    representative.kycId,
  );
  logger('DeleteKyc usersThatShareKyc', false, usersThatShareKyc);

  const removePromises: Promise<FinancialAccountUserAssociation>[] =
    usersThatShareKyc
      .filter(
        (u) =>
          u.userId !== undefined &&
          u.finAcctId !== undefined &&
          u.acctId !== undefined,
      )
      .map((user) =>
        (async (): Promise<FinancialAccountUserAssociation> => {
          logger(
            `DeleteKyc deleting financial account user association between ${user.finAcctId} and ${user.userId}`,
          );
          // user.finAcctId and user.userId confirmed to not be undefined in filter
          await OrgsService.deleteFinancialAcctUser(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            user.finAcctId!,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            user.userId!,
          );

          if (financialAccount.processor === 'STRIPE') {
            logger(
              'DeleteKyc deleting account representative',
              false,
              user.acctId,
              stripeEnv,
            );
            try {
              // user.acctId confirmed to not be undefined in filter
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              await removeAccountRepresentative(user.acctId!, stripeEnv);
            } catch (e) {
              logger(
                `DeleteKyc could not remove account rep for ${user.acctId}`,
              );
            }
          } else if (financialAccount.processor === 'UNIT') {
            throw new Error('Unit not yet implemented');
          }

          // user.finAcctId and user.userId confirmed to not be undefined in filter
          return {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            finAcctId: user.finAcctId!,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: user.userId!,
          };
        })(),
      );

  const successData = await Promise.all(removePromises);
  if (onSuccess !== undefined) {
    logger(`DeleteKyc successData ${JSON.stringify(successData)}`);
    onSuccess(successData);
  }
};

export default submit;
